module.exports = __webpack_public_path__ + "static/img/new2.a822c95.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new2.jpeg
// module id = 6Au/
// module chunks = 0